const MapboxConfig = {
  accessToken:
    "pk.eyJ1IjoiZW9tYXAiLCJhIjoiY2tkZnhvaDJiMjAzeTM2bWh3cHlpN3o0NyJ9.f24MRfc5um4GmKiQC5bCoQ",
  style: "mapbox://styles/mapbox/streets-v11",
  center: [37, -25],
};

export default MapboxConfig;
